module.exports = __webpack_public_path__ + "static/media/EdTechAccelerator.8206a20c.webp";